import { useContext, useState } from 'react';
import StyledChatToggleButton from '../../styles/StyledChatToggleButton';
import { ReactSVG } from 'react-svg';
import chatIconUrl from '../../assets/svgs/chatIcon.svg';
import closeIconUrl from '../../assets/svgs/closeIcon.svg';
import ChatToggleButtonBubble from '../ChatToggleButtonBubble/ChatToggleButtonBubble';
import AppContext from '../../contexts/AppContext';
import AppContextType from '../../types/AppContextType';

interface ChatToggleButtonProps {
  chatOpen: boolean;
  setChatOpen: (open: boolean) => void;
  onCloseBubble: () => void;
}

const ChatToggleButton = ({ chatOpen, setChatOpen, onCloseBubble }: ChatToggleButtonProps) => {
  const { configuration, appId } = useContext<AppContextType>(AppContext);
  const [stopShowingBubble, setStopShowingBubble] = useState(!!window.sessionStorage.getItem(`dcinnovationChatBotStopShowingBubble_${appId}`));

  if (!appId) return <></>;
  if (!configuration) return <></>;

  const getBubbleText = () => {
    if (!configuration) return '';
    if (!configuration.translated_labels) return '';

    return configuration.translated_labels.bubble_text;
  };

  const shouldShowBubble = getBubbleText() && !chatOpen && !stopShowingBubble;

  const saveStopShowingBubble = () => {
    window.sessionStorage.setItem(`dcinnovationChatBotStopShowingBubble_${appId}`, 'true');
  };

  const onClick = () => {
    saveStopShowingBubble();
    setStopShowingBubble(true);
    setChatOpen(!chatOpen);
  };

  const closeBubble = () => {
    saveStopShowingBubble();
    setStopShowingBubble(true);
    onCloseBubble();
  };

  return (
    <>
      {shouldShowBubble && <ChatToggleButtonBubble text={getBubbleText()} close={closeBubble} />}
      <StyledChatToggleButton onClick={onClick} $backgroundColor={configuration.theme_color} $chatOpened={chatOpen}>
        {chatOpen && <ReactSVG
          src={closeIconUrl}
          afterInjection={(svg) => {
            svg.classList.add('svg-close-chat');
          }}
        />}

        {!chatOpen && <ReactSVG
          src={chatIconUrl}
          afterInjection={(svg) => {
            svg.classList.add('svg-open-chat');
          }}
        />}
      </StyledChatToggleButton>
    </>
  );
};

export default ChatToggleButton;